"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bannerStack = exports.stackCheck = exports.setBannerStack = exports.getCloseKey = exports.getNeverKey = void 0;
const listRandom_1 = __importDefault(require("../utils/listRandom"));
const getNeverKey = (key) => {
    return localStorage.getItem(`neverSeeAgain_${key}`)
        ? JSON.parse(localStorage.getItem(`neverSeeAgain_${key}`) || "")
        : "";
};
exports.getNeverKey = getNeverKey;
const getCloseKey = (key) => {
    return sessionStorage.getItem(`close_${key}`)
        ? JSON.parse(sessionStorage.getItem(`close_${key}`) || "")
        : "";
};
exports.getCloseKey = getCloseKey;
const setBannerStack = (stack, banner) => {
    if (!stack.find((elem) => elem.bannerKey === banner.bannerKey)) {
        stack.push(banner);
    }
};
exports.setBannerStack = setBannerStack;
let isDefine = false;
let definedValue = undefined;
const stackCheck = (state, stack, key) => {
    if (stack.length > 1 && isDefine === true) {
        return { value: definedValue, isDefine: isDefine, stack: stack };
    }
    if (stack.length === 1) {
        return { value: stack[stack.length - 1], isDefine: isDefine, stack: stack };
    }
    if (stack.length > 1 && isDefine === false) {
        const randomNum = (0, listRandom_1.default)(stack);
        isDefine = true;
        definedValue = stack[randomNum];
        return { value: definedValue, isDefine: isDefine, stack: stack };
    }
    return { value: state, isDefine: isDefine, stack: stack };
};
exports.stackCheck = stackCheck;
exports.bannerStack = [];
